var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0444 3.67295C11.891 2.7757 10.2758 2.77568 9.12234 3.67291ZM13.0444 3.67295L17.9326 7.47503C18.7113 8.08013 19.1667 9.01116 19.1667 9.99687V17.083C19.1667 18.5097 18.0101 19.6663 16.5833 19.6663H5.58333C4.1566 19.6663 3 18.5097 3 17.083L3 9.99723C2.99964 9.01144 3.45465 8.0804 4.23284 7.47524L9.12234 3.67291M12.1234 4.85692C11.5117 4.38103 10.655 4.38103 10.0433 4.85692L5.15366 8.65934C4.74101 8.98024 4.49975 9.47378 4.5 9.99652L4.5 17.083C4.5 17.6813 4.98502 18.1663 5.58333 18.1663H16.5833C17.1816 18.1663 17.6667 17.6813 17.6667 17.083V9.99687C17.6667 9.47389 17.4252 8.98029 17.0124 8.65955L12.1234 4.85692Z",
    fill: "#F1F1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50195 9.08301C10.1895 9.08301 10.752 9.58301 10.752 10.1941V11.5275C10.752 12.1663 10.1895 12.6386 9.50195 12.6386H8.00195C7.2832 12.6386 6.75195 12.1663 6.75195 11.5275V10.1941C6.75195 9.58301 7.2832 9.08301 8.00195 9.08301H9.50195ZM8.00195 10.1941H9.50195V11.5275H8.00195V10.1941Z",
    fill: "#F1F1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.502 9.08301C15.1895 9.08301 15.752 9.58301 15.752 10.1941V11.5275C15.752 12.1663 15.1895 12.6386 14.502 12.6386H13.002C12.2832 12.6386 11.752 12.1663 11.752 11.5275V10.1941C11.752 9.58301 12.2832 9.08301 13.002 9.08301H14.502ZM13.002 10.1941H14.502V11.5275H13.002V10.1941Z",
    fill: "#F1F1F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.752 14.6386C11.752 14.0275 12.2832 13.5275 13.002 13.5275H14.502C15.1895 13.5275 15.752 14.0275 15.752 14.6386V15.9719C15.752 16.6108 15.1895 17.083 14.502 17.083H13.002C12.2832 17.083 11.752 16.6108 11.752 15.9719V14.6386ZM14.502 15.9719H13.002V14.6386H14.502V15.9719Z",
    fill: "#F1F1F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75195 14.6386C6.75195 14.0275 7.2832 13.5275 8.00195 13.5275H9.50195C10.1895 13.5275 10.752 14.0275 10.752 14.6386V15.9719C10.752 16.6108 10.1895 17.083 9.50195 17.083H8.00195C7.2832 17.083 6.75195 16.6108 6.75195 15.9719V14.6386ZM9.50195 15.9719H8.00195V14.6386H9.50195V15.9719Z",
    fill: "#F1F1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHome);
export default __webpack_public_path__ + "static/media/smart-home.8ee5c6bcee97afc173ba297b1ae0ebc3.svg";
export { ForwardRef as ReactComponent };